import React from 'react';
import { create } from '../react-doka/lib/doka.esm.min';
import { isMobile } from 'react-device-detect';
import './ImageSocial.css';
import { FilePond, registerPlugin } from 'react-filepond';
import { s3PublicUpload, s3Get } from "../libs/awsLib";
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageFilter from 'filepond-plugin-image-filter';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';


// Register the plugins
registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageFilter,
    FilePondPluginImagePreview,
    FilePondPluginImageEdit,
    FilePondPluginImageTransform,
    FilePondPluginFileValidateType
);

class ImageSocial extends React.Component {

    constructor(props) {
        super(props);

        //Determine crop ratio -> Output Height : Output Width
        var aspectRatio = 1;
        if (props.outputWidth && props.outputHeight) {
            aspectRatio = props.outputHeight / props.outputWidth;
        }

        this.state = {
            platformType: props.platformType,
            files: [],
            stickers: props.stickers,
            labelIdle: props.labelIdle,
            aspectRatio: aspectRatio,
            outputWidth: props.outputWidth,
            outputHeight: props.outputHeight,
        };

        if (this.props.loadSrc && this.props.loadSrc !== null) {
            this.state.files.push({
                source: this.props.loadSrc,
                options: {
                    type: 'local'
                }
            });
        }

        this.createDoka = this.createDoka.bind(this);
        this.createServer = this.createServer.bind(this);
        this.getLabelIdle = this.getLabelIdle.bind(this);
    }

    /*
    shouldComponentUpdate(nextProps, nextState) {
        console.log("******shouldComponentUpdate this.state.platformType: " + this.state.platformType +", this.props.loadSrc: " + this.props.loadSrc + ", nextProps.loadSrc: " + nextProps.loadSrc)
        return this.props.loadSrc != nextProps.loadSrc;
    }*/

    componentDidUpdate(prevProps) {
        //Reload Image Src IF the imageSrc is different than the current one loaded
        if(this.props.loadSrc !== prevProps.loadSrc) {
            //Just in case the user removed an image (which could cause props.loadSrc != prevProps.loadSrc), check if new loadSrc is null instead of a forced load
            if (this.props.loadSrc && this.props.loadSrc !== null) {
                //reload file list if the loadSrc was updated by parent
                this.setState({
                    files: [{
                        source: this.props.loadSrc,
                        options: {
                            type: 'local'
                        }
                    }]
                });
            }
        }
    } 

    createDoka() {
        return create(
            {
                utils: ["sticker", "crop", "filter", "color"],
                stickers: this.state.stickers,
                outputWidth: this.state.outputWidth,
                outputHeight: this.state.outputHeight,
                labelButtonUtilSticker: "Stamps",
                imagePreviewScaleMode: "crop",
                /* crop configuration */
                crop: {
                    aspectRatio: this.state.aspectRatio},
                cropAllowResizeRect: false,
                cropAspectRatio: this.state.aspectRatio,
            });
    }

    createServer() {
        return {
            // server to simulate loading a 'local' server file and processing a file
            process: async (fieldName, file, metadata, load) => {
                //Update filename to make it easier for user to process for their social channels
                //File name will follow the following naming convention:
                //  sertify_<media>_<imageType, i.e. coverphoto/gallery>_<random number>_<datestring>.<ext>
                //  i.e. sertify_facebook_coverphoto_123_20201018.png
                //NOTE: A bit of a hack to get the extension, and then replace the prefix of the filename 
                var tempFileName = '';
                const lastDot = file.name.lastIndexOf('.');
                const fileExt = file.name.substring(lastDot + 1);
                if (this.state.platformType === 'facebook') {
                    tempFileName = 'sertify_facebook_coverphoto.' + fileExt;
                } else if (this.state.platformType === 'google') {
                    tempFileName = 'sertify_google_gallery.' + fileExt;
                } else if (this.state.platformType === 'instagram') {
                    tempFileName = 'sertify_instagram_gallery.' + fileExt;
                } else if (this.state.platformType === 'yelp') {
                    tempFileName = 'sertify_yelp_gallery.' + fileExt;
                }
                file.name = tempFileName;

                const s3FileName = file ? await s3PublicUpload(file) : null;
                file.name = s3FileName;
                load();
                //await load(s3FileName);
                await this.props.setImageObject(s3FileName, this.state.platformType);
                


                load();
            },
            load: async (source, load) => {
                try {
                    const s3FileName = await s3Get(source);
                    // simulates loading a file from the server
                    await fetch(s3FileName)
                    .then(res => {
                        if (!res.ok) {
                            throw new Error(res.status);
                        } 
                        return res.blob();
                    })
                    .then(load)
                
                } catch (e) {
                    //Error loading file, load empty
                    load();
                }
                
            },
            revert: async (uniqueFileId, load, error) => {
                //console.log('server.revert: ' + uniqueFileId);
                load();
            },
            restore: async (load) => {
                //console.log('server.restore');
            },
            fetch: async (load) => {
                //console.log('server.fetch');
            },
            patch: async (load) => {
                //console.log('server.patch');
            },
        };
    }

    /**
     * Helper method to add additional FilePond label text based on platform type
     * @param {String} platformType 
     */
    getLabelIdle(platformType) {
        var label = 'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>';
        if (isMobile) {
            //mobile is narrower, hence all info icon display at bottom
            label = '<span class="filepond--label-action"> Browse</span>';
        }

        var platformLabel = "<strong>_replace Photo</strong><br/>"
        if (platformType === 'facebook') {
            platformLabel = platformLabel.replace("_replace", "Facebook");
        } else if (platformType === 'google') {
            platformLabel = platformLabel.replace("_replace", "Google");
        } else if (platformType === 'yelp') {
            platformLabel = platformLabel.replace("_replace", "Yelp");
        } else if (platformType === 'instagram') {
            platformLabel = platformLabel.replace("_replace", "Instagram");
        } else {
            platformLabel = "";
        }
        return platformLabel + label;
    }

    render() {
        return (
            <div className="ImageSocial">
                <FilePond
                    name={this.state.platformType}
                    //style={{ width: '1080px', height: '1080px' }}
                    acceptedFileTypes={['image/png', 'image/jpg', 'image/jpeg']}
                    labelIdle={this.getLabelIdle(this.state.platformType)}
                    files={this.state.files}
                    server={this.createServer()}
                    allowMultiple={false}
                    allowRemove={true}
                    styleItemPanelAspectRatio={1} //sets the filepond preview panel ratio (i.e. the preview box)
                    //imageCropAspectRatio={this.state.aspectRatio}  //defaults the image's crop ratio
                    imageEditEditor={this.createDoka()}
                    onupdatefiles={fileItems => {

                        this.setState({
                            files: fileItems.map(fileItem => fileItem.file)
                        });
                        
                    }}
                    onremovefile={async (error, file) => {
                        //hack: only call removeImageObject if the remove was triggered by a user
                        if (this.props.loadSrc === file.filename) {
                            await this.props.removeImageObject(file.filename, this.state.platformType);
                        }
                    }}
                    onprocessfile={(error, file) => {
                    }}
                    
                />
            </div>
        );
    }
}

export default ImageSocial;